import React, { useEffect } from "react";
import Header from "../components/Header/Header";
import HeroSection from "../components/Hero/HeroSection";
import HowItWorks from "../components/how-it-works/HowItWorks";
import TopIssuesSection from "../components/trending/TopIssuesSection";
import TopSolversSection from "../components/trending/TopIssueSolvers";
import styled from "styled-components";
import AnimatedSection from "../components/AnimatedSection";
import SolarSystemBackground from "../components/SolarSystemBackround";
import WhatWeFace from "../components/WhatWeFace";
import OffersSection from "../components/WhatWeOffer";
import FeaturesSection from "./KeyFeatures";
import ForDevelopersSection from "./ForDevelopers";
import ForCompaniesSection from "./ForCompaniesSection";
import LeaderboardSection from "./LeaderBoardSection";
import RecentIssuesSection from "./RecentCodeIssues";
import CommunityStatsSection from "./CommunityStatsSection";
import RatingsReviewsSection from "./RatingReviewSection";
import HomeFreelanceProjects from "./HomeFreelanceProjects";
import CoinsInfoSection from "./CoinsInfoSection";
import ForDevelopersAISection from "./ForDevelopersAiSection";
import useSEO from "../hooks/useSeo";
import AIInstantSolutionSection from "./AiInstantSolutionSection";
import AllnterviewPrepSection from "./AllInterviewPrepSection";

const AppWrapper = styled.div`
  background: radial-gradient(circle at top left, #0b0617, #000);
  color: #e0e0e0;
`;

const Home = () => {
  useSEO({
    title: "Solve My Code Issue | Fix Code Instantly",
    description:
      "Post your coding issues, hire developers, and fix bugs instantly on SolveMyCodeIssue.com.",
    keywords:
      "solve my code issue, post coding issue online, get code fixed, hire developers",
    canonical: "https://solvemycodeissue.com/",
    ogImage: "https://solvemycodeissue.com/og-image-home.png",
  });
  return (
    <AppWrapper>
      <AnimatedSection>
        <HeroSection />
      </AnimatedSection>

      <AnimatedSection>
        <HowItWorks />
      </AnimatedSection>
      <AnimatedSection>
        <AIInstantSolutionSection />
      </AnimatedSection>
      {/* <AnimatedSection>
        <AllnterviewPrepSection />
      </AnimatedSection> */}
      <AnimatedSection>
        <RecentIssuesSection />
      </AnimatedSection>
      <AnimatedSection>
        <ForDevelopersAISection />
      </AnimatedSection>
      <AnimatedSection>
        <CoinsInfoSection />
      </AnimatedSection>
      <AnimatedSection>
        <HomeFreelanceProjects />
      </AnimatedSection>

      <AnimatedSection>
        <FeaturesSection />
      </AnimatedSection>

      <AnimatedSection>
        <ForDevelopersSection />
      </AnimatedSection>

      <AnimatedSection>
        <ForCompaniesSection />
      </AnimatedSection>

      <AnimatedSection>
        <LeaderboardSection />
      </AnimatedSection>

      <AnimatedSection>
        <RatingsReviewsSection />
      </AnimatedSection>

      <AnimatedSection>
        <CommunityStatsSection />
      </AnimatedSection>
    </AppWrapper>
  );
};

export default Home;
